import { FormGroup, NG_VALIDATORS, ValidationErrors, Validator } from '@angular/forms';
import { Directive, forwardRef, Input } from '@angular/core';

@Directive({
  selector: '[capTagebuchValidator]',
  providers: [{ provide: NG_VALIDATORS, useExisting: forwardRef(() => TagebuchValidatorDirective), multi: true }]
})
export class TagebuchValidatorDirective implements Validator {
  @Input() doValidate = false;

  validate(control: FormGroup): ValidationErrors {
    if (this.doValidate) {
      const grundbuchgeschaeft = control;
      const nummer = control.controls['tagebuchnummer.nummer'];
      const jahr = control.controls['tagebuchnummer.jahr'];
      const grundbuchamtId = control.controls['grundbuchamt.grundbuchamtId'];

      const grundbuchgeschaeftNotNull =
        grundbuchgeschaeft &&
        grundbuchgeschaeft.value &&
        grundbuchamtId &&
        grundbuchamtId.value != null &&
        jahr &&
        jahr.value != null &&
        nummer &&
        nummer.value != null;

      const grundbuchgeschaeftNullOrEmpty =
        grundbuchgeschaeft &&
        grundbuchgeschaeft.value &&
        grundbuchamtId &&
        (grundbuchamtId.value == null || grundbuchamtId.value === '') &&
        jahr &&
        (jahr.value == null || jahr.value === '') &&
        nummer &&
        (nummer.value == null || nummer.value === '');

      const grundbuchgeschaeftNotEmpty =
        grundbuchgeschaeft &&
        grundbuchgeschaeft.value &&
        grundbuchamtId &&
        grundbuchamtId.value !== '' &&
        jahr &&
        jahr.value !== '' &&
        nummer &&
        nummer.value !== '';

      return (grundbuchgeschaeftNotNull && grundbuchgeschaeftNotEmpty) || grundbuchgeschaeftNullOrEmpty ? null : { minimumEingabe: true };
    } else {
      return null;
    }
  }
}
